














































import { defineComponent, ref, computed, PropType } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import AppAvatar from '~/components/partials/App/AppAvatar.vue';
import AppClamp from '~/components/partials/App/AppClamp.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLikeButton from '~/components/partials/App/AppLikeButton.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { url } from '~/utils';
import { CommentData } from '~/types/modules/comment';

export default defineComponent({
  components: {
    AppAvatar,
    AppIcon,
    AppLink,
    AppLikeButton,
    AppClamp,
  },
  props: {
    comment: {
      type: Object as PropType<CommentData>,
      required: true,
    },
    isCommentLiked: {
      type: Boolean,
      default: false,
    },
    hasLikeButton: {
      type: Boolean,
      default: true,
    },
    // 商品詳細画面では簡易レイアウト
    isItemDetail: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const likeOffset = ref(0);
    const likeCount = computed(() => (props.comment.like || 0) + likeOffset.value);
    const vintageCode = computed(() => {
      return props.comment?.metadata?.sku || '';
    });

    const formattedCreatedAt = computed(() => {
      return dayjs(props.comment.created_at).isValid()
        ? dayjs(props.comment.created_at).tz('Asia/Tokyo').format('YYYY.MM.DD')
        : '';
    });
    const handleLikeChange = (isCommentLiked: boolean) => {
      likeOffset.value += isCommentLiked ? 1 : -1;
      emit('change', isCommentLiked, props.comment.id);
    };
    return {
      props,
      url,
      likeCount,
      vintageCode,
      formattedCreatedAt,
      handleLikeChange,
    };
  },
});
